import request from '@/utils/request';
/* 列表 */
export function queryUserMemberLevelPageList (data) {
  return request({
    url: '/user/member/level/queryUserMemberLevelPageList',
    method: 'POST',
    data
  });
}
/* 删除会员等级规则表 */
export function removeUserMemberLevelById (data) {
  return request({
    url: '/user/member/level/removeUserMemberLevelById',
    method: 'POST',
    data
  });
}
/* 新增会员等级规则表 */
export function saveUserMemberLevel (data) {
  return request({
    url: '/user/member/level/saveUserMemberLevel',
    method: 'POST',
    data
  });
}
/* 编辑会员等级规则表 */
export function updateUserMemberLevel (data) {
  return request({
    url: '/user/member/level/updateUserMemberLevel',
    method: 'POST',
    data
  });
}
/* 获取会员等级规则表明细 */
export function fetchUserMemberLevelDetailById (data) {
  return request({
    url: '/user/member/level/fetchUserMemberLevelDetailById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/level.js